/**
 * Link Actions
 */
export enum BottomSheetLinkActionEnum {
    COPY = 'COPY',
    QRCODE = 'QRCODE',
    REDIRECTION = 'REDIRECTION',
}
